import React, { useState, useRef, useEffect } from 'react';
import { Unstable_Popup as Popup } from '@mui/base/Unstable_Popup';

export function ButtonWithPopup(props) {
  const popupRef = useRef();
  const buttonRef = useRef();
  const [popupAnchor, setPopupAnchor] = useState(null);
  const [hover, setHover] = useState(false);
  const popupOpen = props.popupOpen == null ? true : props.popupOpen;
  const propsPopupStyle = props.popupStyle ? props.popupStyle : {};
  const propsButtonStyle = props.buttonStyle ? props.buttonStyle : {};
  const isOpen = Boolean(popupAnchor) && popupOpen;

  useEffect(() => {
    function checkIfClickShouldClosePopup(event) {
        const clickedInsideAutocomplete =
          event.target.closest &&
          event.target.closest('.fancy-autocomplete-popper, .MuiAutocomplete-popper, [role="listbox"]');
        if (clickedInsideAutocomplete) {
            return;
        }
        const clickedOutsidePopup = popupRef.current && !popupRef.current.contains(event.target);
        const clickedOutsideButton = buttonRef.current && !buttonRef.current.contains(event.target);
        if (clickedOutsidePopup && clickedOutsideButton) {
            setPopupAnchor(null);
            if(props.setPopupOpen)
              props.setPopupOpen(false);
        }
    }
    document.addEventListener("mousedown", checkIfClickShouldClosePopup);
    return () => {
      document.removeEventListener("mousedown", checkIfClickShouldClosePopup);
    };
  }, [popupRef]);

  const handleButtonClick = (event) => {
      if (props.toggleOnClick && isOpen) {
        setPopupAnchor(null);
        if(props.setPopupOpen)
          props.setPopupOpen(false);
        return;
      }
      setPopupAnchor(event.currentTarget);
      if(props.onClick)
        props.onClick();
      if(props.setPopupOpen)
        props.setPopupOpen(true);
  }

  // Match the FancyButton primary look: pearl-white gradient, dark text, neutral
  // border, soft drop shadow that deepens and lifts on hover/open.
  const isLifted = hover || isOpen;

  const containerStyle = {
      position: 'relative',
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'start',
      height: '48px',
      borderRadius: '999px',
      cursor:'pointer',
      paddingLeft:'20px',
      paddingRight: '20px',
      color: '#0f0f0f',
      fontWeight: 600,
      fontSize: '13.5px',
      letterSpacing: '0.2px',
      whiteSpace: 'nowrap',
      userSelect: 'none',
      border: `1px solid rgba(0, 0, 0, ${isLifted ? 0.22 : 0.14})`,
      background: isLifted
        ? 'linear-gradient(135deg, #ffffff 0%, #fafafa 45%, #ececec 100%)'
        : 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 45%, #e7e7e7 100%)',
      boxShadow: isLifted
        ? '0 2px 4px rgba(0, 0, 0, 0.08), 0 10px 22px rgba(0, 0, 0, 0.14), inset 0 1px 0 rgba(255, 255, 255, 1), inset 0 -1px 0 rgba(0, 0, 0, 0.08)'
        : '0 1px 1px rgba(0, 0, 0, 0.06), 0 4px 14px rgba(0, 0, 0, 0.10), inset 0 1px 0 rgba(255, 255, 255, 0.95), inset 0 -1px 0 rgba(0, 0, 0, 0.05)',
      transform: isLifted ? 'translateY(-1px)' : 'translateY(0)',
      transition: 'transform 140ms cubic-bezier(0.2, 0.8, 0.4, 1), box-shadow 200ms ease, border-color 180ms ease, background 220ms ease',
      ...propsButtonStyle
  }

  const popupStyle = {
      zIndex:9999,
      marginTop:'10px',
      boxShadow:'0 12px 36px rgba(20, 30, 80, 0.14), 0 2px 6px rgba(20, 30, 80, 0.06)',
      borderRadius: '14px',
      backgroundColor:'white',
      border: '1px solid rgba(0, 0, 0, 0.08)',
      paddingTop:'12px',
      paddingBottom:'12px',
      ...propsPopupStyle
  }

  return (
    <>
    <div
        style={containerStyle}
        onClick={handleButtonClick}
        onMouseEnter={()=>setHover(true)}
        onMouseLeave={()=>setHover(false)}
        ref={buttonRef}
    >
        {props.buttonComponent}
    </div>
    <Popup open={isOpen} anchor={popupAnchor} style={popupStyle} ref={popupRef} className={props.popupClassName}>
        {props.popupComponent}
    </Popup>
    </>
  );
}
